module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav center-width"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "nav-list"
  }, [_c('li', [_c('a', {
    class: {
      active: _vm.isIndex
    },
    attrs: {
      "href": "index.html"
    }
  }, [_vm._v("首页")])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      active: _vm.isSpot
    },
    attrs: {
      "href": "spot.html"
    }
  }, [_vm._v("现货资源")])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      active: _vm.isArticle
    },
    attrs: {
      "href": "article.html"
    }
  }, [_vm._v("全部文章")])])]), _vm._v(" "), _c('div', {
    staticClass: "search right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyWord),
      expression: "keyWord"
    }],
    attrs: {
      "type": "text",
      "placeholder": "品种/规格"
    },
    domProps: {
      "value": (_vm.keyWord)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchSpots.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyWord = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.searchSpots
    }
  }, [_vm._v("搜索")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo-wrap"
  }, [_c('img', {
    staticClass: "logo-img",
    attrs: {
      "src": require("../../assets/images/common/new_logo.png")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "logo-text"
  }, [_vm._v("上海商晟通云网络科技有限公司")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-55c2ed45","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/common/nav.vue
// module id = 459
// module chunks = 0 1 4 5 6 7 8 9 10 11